import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative bg-background-50">
      <Header />
      <main>
        <Hero />
        <AppSection />
        <FaqSection />
        <ContactSection />
        <TopicsSection />
        <AboutSection />
        <UpdatesSection />
        <IndexSection />
        <MediaSection />
        <RankingSection />
        <CardsSection />
        <FeaturesSection />
        <CarouselSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}